(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Get the section element
    var section = document.querySelector('#contactForm');
    if (!section) return;
    
    // Get the form element
    var form = section.querySelector('form[action]');
    if (!form) return;
    
    // Add button hover effect dynamically (optional)
    var button = form.querySelector('.rs-btn');
    var buttonColor = '{{ section.settings.button_color | default: "#1da3d8" }}';
    var buttonHoverColor = '{{ section.settings.button_hover_color | default: "#1da3d8" }}';
    
    if (button) {
        button.addEventListener('mouseenter', function() {
            this.style.backgroundColor = buttonHoverColor;
        });
        
        button.addEventListener('mouseleave', function() {
            this.style.backgroundColor = buttonColor;
        });
    }
    
    // Auto-hide alerts after 5 seconds
    var alerts = section.querySelectorAll('.alert');
    alerts.forEach(function(alert) {
        setTimeout(function() {
            alert.style.opacity = '0';
            alert.style.transition = 'opacity 0.5s ease';
            setTimeout(function() {
                alert.style.display = 'none';
            }, 500);
        }, 5000);
    });
    
    // Form validation enhancements
    form.addEventListener('submit', function(e) {
        var requiredFields = this.querySelectorAll('[required]');
        var isValid = true;
        
        requiredFields.forEach(function(field) {
            if (!field.value.trim()) {
                isValid = false;
                field.style.borderColor = '#dc3545';
                field.style.backgroundColor = '#fff8f8';
                
                // Reset styling on input
                field.addEventListener('input', function() {
                    this.style.borderColor = '';
                    this.style.backgroundColor = '';
                });
            } else {
                field.style.borderColor = '';
                field.style.backgroundColor = '';
            }
        });
        
        if (!isValid) {
            e.preventDefault();
            // Show error message at the top of the form
            var errorContainer = form.querySelector('.alert-danger');
            if (!errorContainer) {
                // Create one if it doesn't exist
                var alertDiv = document.createElement('div');
                alertDiv.className = 'alert alert-danger';
                alertDiv.textContent = 'Please fill in all required fields.';
                form.insertBefore(alertDiv, form.firstChild);
            } else {
                errorContainer.style.display = 'block';
                errorContainer.textContent = 'Please fill in all required fields.';
            }
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var section = document.querySelector('#sectionMap');
    if (!section) return;
    
    var iframe = section.querySelector('iframe');
    if (!iframe) return;
    
    // Check if controls should be disabled
    var zoomControl = '{{ section.settings.enable_zoom_control }}';
    var fullscreenControl = '{{ section.settings.enable_fullscreen_control }}';
    
    if (zoomControl === 'false' || fullscreenControl === 'false') {
        // For maps with controls disabled, we need to modify the src
        var src = iframe.src;
        var modifiedSrc = src;
        
        // Remove existing controls if any
        modifiedSrc = modifiedSrc.replace(/&amp;zoom_control=([^&]*)/g, '');
        modifiedSrc = modifiedSrc.replace(/&amp;fullscreen_control=([^&]*)/g, '');
        
        // Add controls parameter
        var controlsParam = '';
        if (zoomControl === 'false') {
            controlsParam += '&amp;zoom_control=false';
        }
        if (fullscreenControl === 'false') {
            controlsParam += '&amp;fullscreen_control=false';
        }
        
        if (controlsParam) {
            if (modifiedSrc.indexOf('?') === -1) {
                modifiedSrc += '?';
            } else {
                modifiedSrc += '&amp;';
            }
            modifiedSrc += controlsParam.replace(/&amp;/, '');
        }
        
        if (modifiedSrc !== src) {
            iframe.src = modifiedSrc;
        }
    }
    
    // Lazy loading enhancement
    if ('IntersectionObserver' in window && '{{ section.settings.map_lazy_load }}' === 'true') {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var iframeElement = entry.target;
                    var src = iframeElement.getAttribute('data-src');
                    if (src) {
                        iframeElement.src = src;
                        iframeElement.removeAttribute('data-src');
                    }
                    observer.unobserve(iframeElement);
                }
            });
        });
        
        if (iframe.hasAttribute('loading') && iframe.getAttribute('loading') === 'lazy') {
            iframe.setAttribute('data-src', iframe.src);
            iframe.src = 'about:blank';
            observer.observe(iframe);
        }
    }
    
    // Add hover effect to show map controls on desktop
    var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (!isTouchDevice) {
        var mapContainer = section.querySelector('.map-container');
        if (mapContainer) {
            mapContainer.addEventListener('mouseenter', function() {
                var iframeEl = this.querySelector('iframe');
                if (iframeEl && iframeEl.style.filter) {
                    iframeEl.style.filter = 'none';
                }
            });
            
            mapContainer.addEventListener('mouseleave', function() {
                var iframeEl = this.querySelector('iframe');
                if (iframeEl && iframeEl.style.filter) {
                    var style = '{{ section.settings.map_style }}';
                    if (style === 'grayscale') {
                        iframeEl.style.filter = 'grayscale(100%)';
                    } else if (style === 'sepia') {
                        iframeEl.style.filter = 'sepia(80%)';
                    } else if (style === 'dark') {
                        iframeEl.style.filter = 'brightness(0.7) contrast(1.2)';
                    } else {
                        iframeEl.style.filter = 'none';
                    }
                }
            });
        }
    }
});

  } catch(e) { console.error(e); }
})();
})();
